export default __webpack_public_path__ + "assets/009bc730e182b6896d29a79b131042a6.svg";